import script from "./Welcome16167Intro.vue?vue&type=script&setup=true&lang=ts"
export * from "./Welcome16167Intro.vue?vue&type=script&setup=true&lang=ts"

import "./Welcome16167Intro.vue?vue&type=style&index=0&id=e42262ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e42262ae"]])

export default __exports__